import { Enemy } from '../../types';
import './CombatTracker.css';

interface CombatTrackerProps {
  enemies: Enemy[];
}

export function CombatTracker({ enemies }: CombatTrackerProps) {
  if (enemies.length === 0) return null;

  const getHpPercent = (hp: number, maxHp: number) => (hp / maxHp) * 100;
  const getHpColor = (hp: number, maxHp: number) => {
    const percent = getHpPercent(hp, maxHp);
    if (percent > 50) return 'hp-high';
    if (percent > 25) return 'hp-medium';
    return 'hp-low';
  };

  return (
    <div className="combat-tracker">
      <h3 className="combat-tracker-title">Enemies</h3>
      <div className="enemy-list">
        {enemies.map((enemy, index) => (
          <div key={index} className="enemy-card">
            <div className="enemy-header">
              <span className="enemy-name">{enemy.name}</span>
              <span className="enemy-class">{enemy.class}</span>
            </div>
            <div className="enemy-hp-bar">
              <div 
                className={`enemy-hp-fill ${getHpColor(enemy.hp, enemy.maxHp)}`}
                style={{ width: `${getHpPercent(enemy.hp, enemy.maxHp)}%` }}
              />
            </div>
            <div className="enemy-hp-text">
              {enemy.hp} / {enemy.maxHp} HP
            </div>
            <div className="enemy-weapon">
              {enemy.weapon}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
